// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "../../../../../../node_modules/rescript/lib/es6/caml_option.js";

function useToast(durationOpt, param) {
  var duration = durationOpt !== undefined ? durationOpt : 3000;
  var match = React.useState(function () {
        return {
                visible: false,
                toastType: /* Success */0,
                message: ""
              };
      });
  var setState = match[1];
  var timerRef = React.useRef(undefined);
  var clearTimer = function (param) {
    var id = timerRef.current;
    if (id !== undefined) {
      clearTimeout(Caml_option.valFromOption(id));
      timerRef.current = undefined;
      return ;
    }
    
  };
  var show = function (toastType, message) {
    clearTimer(undefined);
    Curry._1(setState, (function (param) {
            return {
                    visible: true,
                    toastType: toastType,
                    message: message
                  };
          }));
    var id = setTimeout((function (param) {
            Curry._1(setState, (function (prev) {
                    return {
                            visible: false,
                            toastType: prev.toastType,
                            message: prev.message
                          };
                  }));
            timerRef.current = undefined;
            
          }), duration);
    timerRef.current = Caml_option.some(id);
    
  };
  var showSuccess = function (message) {
    return show(/* Success */0, message);
  };
  var showFailure = function (message) {
    return show(/* Failure */1, message);
  };
  React.useEffect((function () {
          return (function (param) {
                    return clearTimer(undefined);
                  });
        }), []);
  return [
          match[0],
          showSuccess,
          showFailure
        ];
}

export {
  useToast ,
  
}
/* react Not a pure module */
